import moment from "moment";
import { BACKEND_URL } from "../services/backendURL";
import { replaceAlbanianChars } from "./StringFormatter";


export const filterOption = (input, option) => {
    return replaceAlbanianChars(option?.children).includes(replaceAlbanianChars(input));
};


export const setFormFieldValue = (givenValue) => {
    if (isValidValue(givenValue) === false) {
        return null;
    }
    return givenValue;
};


export const setEmptyStringValue = (givenValue) => {
    if (isValidValue(givenValue) === false) {
        return "";
    }
    return givenValue;
};


export const setDateFieldValue = (givenDate, dateFormat) => {
    if (isValidValue(givenDate) === false) {
        return null;
    }

    const formattedDate = moment(givenDate, dateFormat);
    return formattedDate;
};


export const setDateValue = (givenDate, dateFormat) => {
    if (isValidValue(givenDate) === false) {
        return null;
    }

    const formattedDate = moment(givenDate).format(dateFormat);
    return formattedDate;
};


export const formatIntegerId = (givenId) => {
    if (isValidValue(givenId) === false) {
        return null;
    }

    return parseInt(givenId);
};


export const isValidValue = (value) => {
    if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "null" ||
        value === "undefined"
    ) {
        return false;
    }
    return true;
};


export const setDisabledDates = (currentDate, givenDate) => {
    const formattedDate = moment(givenDate).format("YYYY-MM-DD");
    return currentDate && currentDate < moment(formattedDate, "YYYY-MM-DD");
};


export const setPhone = (phone) => {
    if (isValidValue(phone) === false) {
        return null;
    }

    if (phone?.includes("+355")) {
        const phoneArray = phone?.split("+355");
        if (phoneArray?.length > 1) {
            return phoneArray[1];
        }
    }

    return phone;
};


export const setUrlFile = (file) => {
    if (isValidValue(file) === false) {
        return null;
    }

    return BACKEND_URL + file;
};


export const setMapLocation = (location) => {
    if (location && location.length > 0) {
        let formatedLocation = location.split(",");
        const latitute = formatedLocation[0];
        const longitude = formatedLocation[1];

        location = {
            lat: parseFloat(latitute),
            lng: parseFloat(longitude),
        };

        return location;
    }

    return null;
};


export const getYearFirstDate = (year) => {
    if (year) {
        const firstDate = moment(year.toString() + "-01-01").startOf(year);
        return firstDate;
    }

    return null;
};


export const getHoursDifference = (date1, date2) => {
    const difference = (date1 - date2) / 3600000;
    return difference;
};


export const getDaysDifference = (date1, date2) => {
    const difference = Math.abs(date2 - date1);
    return difference / (1000 * 60 * 60 * 24);
};


export const getYearLastDate = (year) => {
    if (year) {
        const lastDate = moment(year.toString() + "-12-31").endOf(year);
        return lastDate;
    }

    return null;
};


export const disabledYears = (current) => {
    const startText = moment().year().toString() + "-01-01";
    const startDate = moment(startText);
    return current < startDate;
};


export const isInteger = (givenValue) => {
    const isValid = isValidValue(givenValue);

    if (isValid === false) {
        return false;
    }

    const validFormat = /^\d+$/.test(givenValue);
    return validFormat;
};


export const isDouble = (givenValue) => {
    const isValid = isValidValue(givenValue);

    if (isValid === false) {
        return false;
    }

    const validFormat = /^[\d,]*\.?\d+$/.test(givenValue);
    return validFormat;
};


export const isEmptyString = (givenValue) => {
    const isValid = isValidValue(givenValue);
    if (isValid === false) {
        return false;
    }

    const validFormat = !/\S/.test(givenValue);
    return validFormat;
};


export const getMomentDate = (givenDate) => {
    if (givenDate?._d) {
        return givenDate?._d;
    }

    if (givenDate?.$d) {
        return givenDate?.$d
    }
};


export const setMomentDate = (givenStringDate) => {
    return moment(givenStringDate, "YYYY-MM-DD");
};


export const formatPercentage = (value, decimals = 2) => {
    if (isNaN(value) || value < 0) {
        return null;
    }

    const formattedValue = parseFloat(value)?.toFixed(decimals);
    return formattedValue + " %";
};


export const isValidVideoType = (videoUploaded) => {
    const isValidVideo =
        videoUploaded.type === "video/mp4" ||
        videoUploaded.type === "video/mpg" ||
        videoUploaded.type === "video/mov" ||
        videoUploaded.type === "video/webm";
    return isValidVideo;
};